export default __webpack_public_path__ + "static/media/resume-session-icon.6da2353b.svg";